import { isAndroid, isIOS, loadScript } from '../core/util';
const NET_MAP = {
  0: 'none',
  1: 'wifi',
  2: '2g',
  3: '3g',
  4: '4g',
};

const JSBRIDGE_TIMEOUT = 5000;

const weishiSdk = '//qzonestyle.gtimg.cn/qzone/hybrid/app/weishi/lib/wsapi.js';

function checkJSBridgeReady(JSBNS, callback) {
  console.log('weishi checkJSBridgeReady JSBNS=', JSBNS);
  console.log('weishi checkJSBridgeReady mqq=', window.mqq);
  // callback(window.mqq);
  if (JSBNS) {
    callback(JSBNS);
  } else if (window.mqq && window.mqq.invoke) {
    callback(window.mqq);
  } else {
    loadScript(weishiSdk).then(() => {
      callback(window.mqq);
    });
  }
}
export default function (JSBNS, callback) {
  checkJSBridgeReady(JSBNS, (JSBNS) => {
    const params = {
      /*
            loginInfo: () => {
                let cookie = parseCookie(document.cookie);
                let iAuthType = cookie.iAuthType;
                let dataList = [
                    {field: 'main_login', value: iAuthType || ''},
                    {field: 'account_id', value: cookie.person_id || ''}
                ];
                return {dataType: 'multi-field', dataList};
            },*/
      network_type: () => {
        console.log('get weishi network_type');
        return new Promise((resolve, reject) => {
          console.log('JSBNS.invoke device gegtNetworkInfo', JSBNS);
          JSBNS.invoke('device', 'getNetworkInfo', (res) => {
            console.log('promise network_type ready:', res);
            resolve((res
                && res.code === 0
                && res.data.type !== undefined
                && NET_MAP[res.data.type])
                || 'unknown');
          });
          setTimeout(() => reject('unknown'), JSBRIDGE_TIMEOUT);
        });
      },
    };
    if (isAndroid) {
      Object.assign(params, {
        deviceInfo: new Promise((resolve, reject) => {
          JSBNS.invoke('device', 'getDeviceInfo', (res) => {
            console.log('promise deviceInfo ready:', res);
            resolve({
              dataType: 'multi-field',
              dataList: [
                {
                  field: 'imei',
                  value: (res.data && res.data.identifier) || '',
                },
                { field: 'imsi', value: '' },
                { field: 'android_id', value: '' },
              ],
            });
          });
          setTimeout(
            () => reject({ dataType: 'multi-field', dataList: [] }),
            JSBRIDGE_TIMEOUT,
          );
        }),
      });
    } else if (isIOS) {
      Object.assign(params, {
        idfa: new Promise((resolve) => {
          JSBNS.invoke('device', 'getDeviceInfo', (param) => {
            resolve(param.idfa || (param.data && param.data.idfa));
          });
        }),
      });
    }
    callback(params);
  });
}
